import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import CallerNumberIsForm from './CallerNumberIsForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(CallerNumberIsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerNumberIs/CallerNumberIsForm.container.js